import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseUIController} from '../base-ui-controller';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {IValidator} from '../../../Directives/directives.helper';
import {LibIconsService} from '../../../services/lib-icons.service';
import { NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TooltipDirective } from '../../../Directives/tooltip.directive';
import { ClickOutsideDirective } from '../../../Directives/clickOutside.directive';
import { InputFileComponent } from '../input-file/input-file.component';
import { MessagesBank } from 'src/app/services/status.service';
import { CopyLinkService } from 'src/app/services/copy-link.service';
import { ALLOWED_URL_SCHEMES } from '../../Definitions/shared.definitions';
export enum IMAGE_SOURCE {
  libIcon,
  localUrl,
  externalUrl,
  selectedFile
}
@Component({
    selector: 'ins-image-picker',
    templateUrl: './image-picker.component.html',
    styleUrls: ['./image-picker.component.scss', '../shared-UI-components.scss'],
    imports: [MatIcon, TooltipDirective, ClickOutsideDirective, NgStyle, InputFileComponent]
})
export class ImagePickerComponent extends BaseUIController {

  @Input() imagesList: string[] = [];
  @Input() unchangeable: boolean = true;
  @Input() imageSource: IMAGE_SOURCE;
  @Output() changeImageSource: EventEmitter<IMAGE_SOURCE> = new EventEmitter();
  showSelector: boolean = false;
  selectorPosition: any = {};
  isExternalImageValid: boolean = false;
  public fileTypeValidator: IValidator[] = [];
  public permittedFilesExtension: string[] = ['.jpg', '.png', '.gif'];
  
  // Copy Icon Name Context menu properties
  showCopyIconContextMenu: boolean = false;
  copyIconContextMenuPosition: any = {};
  selectedImageName: string = '';
  constructor(private readonly sanitizer: DomSanitizer, public libIconSrv: LibIconsService, private readonly copyLinkService: CopyLinkService) {
    super();
    this.fileTypeValidator = [{objectID: 'input', displayText: 'File can be only one of the following types: ' + this.permittedFilesExtension.join(', ')}];
  }

  openSelector(iconButton: any): void {
    this.selectorPosition['top'] = iconButton.offsetTop + 15 + 'px'; // 15px = half of the icon height
    this.selectorPosition['left'] = iconButton.offsetLeft + 15 + 'px'; // 15px = half of the icon width

    this.showSelector = true;
  }

  onImagePicked(event: any): void {
    this.value = event;
    this.changeImageSource.emit(IMAGE_SOURCE.libIcon);
    this.showSelector = false;
  }

  selectExternalImage($event: any): void {
    if (this.isExternalImageValid) {
      this.value = $event;
      this.changeImageSource.emit(IMAGE_SOURCE.selectedFile);
      this.showSelector = false;
    }
  }

  clickOutside(): void {
    if (!this.showCopyIconContextMenu) {
      this.showSelector = false;
    }
  }

  stateIfValid($event: any): void {
    this.isExternalImageValid = $event;
  }

  getImageResult(): string | SafeUrl {
    switch (this.imageSource) {
      case IMAGE_SOURCE.libIcon:
        return this.libIconSrv.getLibIconUrlForDialog(this.value);
      case IMAGE_SOURCE.externalUrl:
        if (this.value?.includes(':') && !ALLOWED_URL_SCHEMES.test(this.value)) {
          console.warn('ImagePickerComponent: blocked potentially unsafe URL scheme:', this.value);
          return '';
        }
        return this.sanitizer.bypassSecurityTrustUrl(this.value); // NOSONAR - URL scheme validated against ALLOWED_URL_SCHEMES allowlist
      case IMAGE_SOURCE.selectedFile:
        return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.value)); // NOSONAR - blob URL created from user-selected File object
      case IMAGE_SOURCE.localUrl:
        return this.value;
      default:
        return '';
    }
  }

  onImageRightClick(event: MouseEvent, imageName: string): void {
    event.preventDefault();
    event.stopPropagation();
    this.selectedImageName = imageName;
    this.copyIconContextMenuPosition = {
      top: event.clientY + 'px',
      left: event.clientX + 'px'
    };
    this.showCopyIconContextMenu = true;
  }

  copyIconName(): void {
    const textToCopy = this.selectedImageName.toString().trim();    
    this.copyLinkService.copyLinkToClipboard(MessagesBank.COPY_ICON_NAME_LINK, textToCopy);
    this.hideCopyIconContextMenu();
  }

  hideCopyIconContextMenu(): void {
    this.showCopyIconContextMenu = false;
  }

  onContextMenuClickOutside(): void {
    this.hideCopyIconContextMenu();
  }
}
